import { useAppContext } from '../context/AppContext';
import { useGlobalError } from '../context/GlobalErrorContext';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export default function GuardedRoute({ children, minStep, maxStep, allowDeeplink = false }) {
  const { state, dispatch } = useAppContext();
  const { showGlobalError } = useGlobalError();
  const navigate = useNavigate();
  const location = useLocation();
  const previousPath = useRef(location.pathname);

  const [searchParams] = useSearchParams();
  const isDeeplink = allowDeeplink && searchParams.size > 0;
  const validPageTransition = isDeeplink || (state.currentStep >= minStep && state.currentStep <= maxStep);

  // Reset state, if page transition is not valid
  useEffect(() => {
    if (validPageTransition) {
      return;
    }

    const processAlreadyFinished = location.pathname === '/danke' || previousPath.current === '/danke';
    const errorMessage = processAlreadyFinished
      ? 'Dein Antrag ist sicher bei uns eingegangen. Du erhältst in Kürze eine E-Mail mit weiteren Informationen.'
      : 'Deine Sitzung ist abgelaufen oder die Seite wurde neu geladen. Bitte starte den Prozess neu.';

    showGlobalError(errorMessage);
    navigate('/tarif-berechnen', { replace: true });
    dispatch({ type: 'RESET_APPLICATION' });
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  // Update previous path ref
  useEffect(() => {
    if (previousPath.current !== location.pathname) {
      previousPath.current = location.pathname;
    }
  }, [location.pathname]);

  // only render page, if transition is valid - otherwise wait for redirect to /tarif-berechnen to finish
  if (!validPageTransition) {
    return null;
  }
  return children;
}
